var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowUpCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3283_4304)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#E6E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.45 9.00457L14.9954 11.55C15.2439 11.7985 15.2439 12.2015 14.9954 12.45C14.7469 12.6985 14.344 12.6985 14.0955 12.45L12.6364 10.9909V14.5455C12.6364 14.8969 12.3515 15.1818 12 15.1818C11.6485 15.1818 11.3636 14.8969 11.3636 14.5455V10.9909L9.90452 12.45C9.65601 12.6985 9.25308 12.6985 9.00457 12.45C8.75605 12.2015 8.75605 11.7985 9.00457 11.55L11.55 9.00457C11.7985 8.75605 12.2015 8.75605 12.45 9.00457Z",
    fill: "#F8009E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12ZM12 6.27273C8.83691 6.27273 6.27273 8.83691 6.27273 12C6.27273 15.1631 8.83691 17.7273 12 17.7273C15.1631 17.7273 17.7273 15.1631 17.7273 12C17.7273 8.83691 15.1631 6.27273 12 6.27273Z",
    fill: "#F8009E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3283_4304"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowUpCircle);
export default __webpack_public_path__ + "static/media/icon-arrow-up-circle.57b02acd0c685376aa813ace46189cc9.svg";
export { ForwardRef as ReactComponent };